// extracted by mini-css-extract-plugin
module.exports = {"container":"Oh","block":"Ph","subheading":"Qh","cta":"Rh","disabled":"Sh","noBotMargin":"Th","light":"Uh"};